import type { ToastOptions } from 'react-hot-toast'
import { alertColors } from '@/theme/colors'

export const ALERT_TOAST_POSITION = 'top-right' as const

export type AlertToastSeverity = 'success' | 'error' | 'info' | 'warning' | 'loading'

const severityKey = (severity: AlertToastSeverity) =>
  severity === 'loading' ? 'info' : severity

export const getAlertToastStyle = (severity: AlertToastSeverity) => {
  const { border, content, background } = alertColors[severityKey(severity)]

  return {
    background,
    color: content,
    border: `1px solid ${border}`,
    boxShadow: '0 4px 12px rgba(17, 25, 39, 0.08)',
    padding: '12px 16px',
    fontSize: 12,
    lineHeight: 1.4,
    maxWidth: 520,
  }
}

export const getAlertToastOptions = (
  severity: AlertToastSeverity,
  options?: ToastOptions
): ToastOptions => {
  const { icon } = alertColors[severityKey(severity)]

  return {
    position: ALERT_TOAST_POSITION,
    ...options,
    style: {
      ...getAlertToastStyle(severity),
      ...options?.style,
    },
    iconTheme: {
      primary: '#FFFFFF',
      secondary: icon,
    },
  }
}
